namespace QuoteManager {

    export interface ICreateQuoteRequest {
        DomainId?: number | null;
        QuoteId?: string | null;
        BasketId: string;
        SharedUse: boolean;
        SendEmail: boolean;
        CultureCode?: string | null;
        EmailAddress?: string | null;
        EmailSignUp: boolean;
        User: IContact | null;
        TrackingTag?: string;
        VisitSourceId?: number | null;
    }

    export interface IContact {
        Title?: string;
        FirstName?: string;
        LastName?: string;
        Email: string | null;
        MobileTel?: string;
    }


    export class QuoteManager {
        private domain: any;
        private url: string = '/api/quotes/';

        constructor (
            private $http: ng.IHttpService,
            private $window,
            private cookieService: any
        ) {
            this.domain = $window.TRPCONFIG.Domain;
        }

        create(params: ICreateQuoteRequest, cache: boolean = true): ng.IPromise<Quote.ICreateQuoteResponse>{
            params.DomainId = params.DomainId || this.domain.DomainId;
            params.CultureCode = params.CultureCode || this.domain.CultureCode;
            params.VisitSourceId = Number(this.cookieService.get('visitSource')) || null;

            return this.$http.post(this.url + 'create', params, {
                cache,
                ignoreErrors: true
            }).then((res) => {
                return res.data;
            }, (res) => {
                return {Error: res.data};
            });
        }
    }

    angular
        .module('TR')
        .service('quoteManager', QuoteManager);
}
